<template>
  <div class="product">
    <div class="img_stock">
      <div class="product_img" @click="goDeatil">
        <img
          v-if="product.spuImg"
          :src="product.spuImg"
          alt=""
          class="img_img"
        />
      </div>
      <div v-if="false" class="stock_off">暂时缺货</div>
    </div>
    <div class="product_name text_left">{{ product.name }}</div>
    <tags
      v-if="$appSource !== 3"
      class="tag_tagbor"
      :tradeType="product.tradeType"
      :tradeTypeName="product.tradeTypeName"
      :includeTax="product.includeTax"
    />
    <div v-else class="tag_tagbor clearfix">
      <logistics-tag
        v-for="type in logisticsTypes"
        :key="type"
        :type="type"
        class="left"
      />
    </div>
    <div class="product_price clearfix">
      <span>{{ product.storePrice | currency(false) }}</span>
      <!-- <img
        v-if="showShare"
        src="@/assets/common/share@2x.png"
        alt=""
        class="share_img right"
        @click="showPoster"
      /> -->
    </div>
  </div>
</template>

<script>
const Tags = () => import("@/components/Tags").then(m => m.default || m);
const LogisticsTag = () =>
  import("@/components/LogisticsTag").then(m => m.default || m);
export default {
  props: {
    showShare: {
      type: Boolean,
      default: true
    },
    product: {
      type: Object,
      default() {
        return {};
      }
    }
  },
  components: {
    Tags,
    LogisticsTag
  },
  data() {
    return {};
  },
  computed: {
    logisticsTypes() {
      let list = this.product.logisticsTypeList;
      if (list === undefined || list === null) return [];
      if (
        typeof list === "string" &&
        list.startsWith("[") &&
        list.endsWith("]")
      ) {
        try {
          list = JSON.parse(list);
        } catch (e) {
          // ignore
        }
      }
      if (Array.isArray(list)) {
        return list.map(Number).filter(v => [0, 1, 2].includes(v));
      }
      if (typeof list === "string") {
        return list
          .split(",")
          .map(v => v.trim())
          .filter(v => v !== "")
          .map(Number)
          .filter(v => [0, 1, 2].includes(v));
      }
      if (typeof list === "number") {
        return [list].filter(v => [0, 1, 2].includes(v));
      }
      return [];
    }
  },
  methods: {
    goDeatil() {
      // this.$emit("goDeatil");
      this.$router.push({
        path: "/product/detail",
        query: {
          id: this.product.id
        }
      });
    },
    showPoster() {
      this.$router.push({
        path: "/product/share",
        query: {
          id: this.product.id
        }
      });
    }
  }
};
</script>
<style lang="less" scoped>
.product {
  background: #fff;
  width: 100%;
  margin-bottom: 0;
  padding-bottom: 4px;
  border-radius: 6px;
  .img_stock {
    position: relative;
    .stock_off {
      font-size: 18px;
      font-weight: 400;
      color: #ffffff;
      line-height: 25px;
      background: #000000;
      opacity: 0.6;
      border-radius: 50%;
      margin: 25px;
      padding: 35px 38px;
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
    }
  }
  .product_img {
    width: 100%;
    height: 170px;
    background-color: #ffffff;
    border-radius: 6px;
    overflow: hidden;
    display: flex;
    align-items: center;
    justify-content: center;
    .img_img {
      width: 100%;
      height: 100%;
      object-fit: cover;
      display: block;
      margin: 0 auto;
      border-radius: 6px 6px 0 0;
    }
  }
  .product_name {
    margin: 8px 8px 4px;
    font-size: 14px;
    font-weight: 400;
    color: #000;
    line-height: 19px;
    text-overflow: -o-ellipsis-lastline;
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    word-wrap: break-word;
    .tag_img {
      height: 13.08px;
      margin-right: 4px;
    }
  }
  .tag_tagbor {
    margin: 0 8px;
  }
  .product_price {
    margin: 8px 8px;
    font-size: 16px;
    font-weight: 600;
    color: #000;
    text-align: left;
    .share_img {
      width: 20px;
    }
  }
}
</style>
